import { render, staticRenderFns } from "./Shudongliebiao.vue?vue&type=template&id=62e56adb&scoped=true&"
import script from "./Shudongliebiao.vue?vue&type=script&lang=js&"
export * from "./Shudongliebiao.vue?vue&type=script&lang=js&"
import style0 from "./Shudongliebiao.vue?vue&type=style&index=0&id=62e56adb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e56adb",
  null
  
)

export default component.exports